(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const syncHeaderHeightVariable = () => {
    const headerSection = document.querySelector('.section-header');
    const headerContainer = headerSection
      ? headerSection.querySelector('.header-wrapper, sticky-header, static-header')
      : document.querySelector('.header-wrapper, sticky-header, static-header');
    const target = headerContainer || headerSection;
    if (!target) return;

    const rect = target.getBoundingClientRect();
    const headerOffset = rect.bottom > 0 ? rect.bottom : rect.height;
    document.documentElement.style.setProperty('--header-height', `${Math.round(headerOffset)}px`);
  };

  let headerHeightRaf = null;
  const scheduleSyncHeaderHeight = () => {
    if (headerHeightRaf != null) return;
    headerHeightRaf = requestAnimationFrame(() => {
      headerHeightRaf = null;
      syncHeaderHeightVariable();
    });
  };

  document.addEventListener('DOMContentLoaded', syncHeaderHeightVariable);
  window.addEventListener('load', syncHeaderHeightVariable);
  window.addEventListener('resize', scheduleSyncHeaderHeight, { passive: true });

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.scrollRaf = null;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.createObserver();
    }

    setHeaderHeight() {
      syncHeaderHeightVariable();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.scrollRaf != null) cancelAnimationFrame(this.scrollRaf);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (this.scrollRaf != null) return;
      this.scrollRaf = requestAnimationFrame(() => {
        this.scrollRaf = null;
        this.applyScrollState();
      });
    }

    applyScrollState() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      // Don't hide/reveal sticky header while the mobile menu is open.
      if (document.documentElement.classList.contains('rn-menu-open')) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) {
          this.currentScrollTop = scrollTop;
          return;
        }
        this.hide();
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          this.reveal();
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          this.hide();
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        this.reset();
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      if (this.header.classList.contains('shopify-section-header-hidden')) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      if (
        this.header.classList.contains('shopify-section-header-sticky') &&
        !this.header.classList.contains('shopify-section-header-hidden')
      ) {
        return;
      }
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      if (
        !this.header.classList.contains('shopify-section-header-hidden') &&
        !this.header.classList.contains('shopify-section-header-sticky')
      ) {
        return;
      }
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      syncHeaderHeightVariable();
    }
  }

  customElements.define('static-header', StaticHeader);

  document.addEventListener('DOMContentLoaded', () => {
    const shopPlusItems = document.querySelectorAll('.shop-plus-menu-item');
    const shopPlusDesktopQuery = window.matchMedia('(min-width: 990px)');
    let shopPlusScrollLocked = false;
    let shopPlusScrollY = 0;

    const isShopPlusTypingTarget = (target) => {
      if (!target || !target.tagName) return false;
      const tag = target.tagName;
      return tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || target.isContentEditable;
    };

    const lockShopPlusScroll = () => {
      if (shopPlusScrollLocked) return;
      shopPlusScrollLocked = true;
      shopPlusScrollY = window.scrollY || document.documentElement.scrollTop || 0;
    };

    const unlockShopPlusScroll = () => {
      if (!shopPlusScrollLocked) return;
      shopPlusScrollLocked = false;
    };

    const blockShopPlusScrollEvent = (event) => {
      if (!shopPlusScrollLocked) return;
      event.preventDefault();
    };

    const blockShopPlusScrollKeys = (event) => {
      if (!shopPlusScrollLocked || isShopPlusTypingTarget(event.target)) return;
      const scrollKeys = { ArrowUp: 1, ArrowDown: 1, PageUp: 1, PageDown: 1, Home: 1, End: 1 };
      if (scrollKeys[event.key]) {
        event.preventDefault();
        return;
      }
      if (
        (event.key === ' ' || event.key === 'Spacebar') &&
        (event.target === document.body || event.target === document.documentElement)
      ) {
        event.preventDefault();
      }
    };

    document.addEventListener('wheel', blockShopPlusScrollEvent, { passive: false });
    document.addEventListener('touchmove', blockShopPlusScrollEvent, { passive: false });
    document.addEventListener('keydown', blockShopPlusScrollKeys);
    let shopPlusScrollRestoreQueued = false;
    window.addEventListener('scroll', () => {
      if (!shopPlusScrollLocked || shopPlusScrollRestoreQueued) return;
      const y = window.scrollY || document.documentElement.scrollTop || 0;
      if (y === shopPlusScrollY) return;
      shopPlusScrollRestoreQueued = true;
      requestAnimationFrame(() => {
        shopPlusScrollRestoreQueued = false;
        if (!shopPlusScrollLocked) return;
        window.scrollTo(0, shopPlusScrollY);
      });
    }, { passive: true });

    const updateShopPlusGlobalState = () => {
      const hasOpenMenu = Array.from(shopPlusItems).some((shopPlusItem) => {
        const panel = shopPlusItem.querySelector('.shop-plus-menu__panel');
        return (
          shopPlusItem.classList.contains('is-open') ||
          shopPlusItem.matches(':hover') ||
          shopPlusItem.matches(':focus-within') ||
          (panel && (panel.matches(':hover') || panel.matches(':focus-within')))
        );
      });
      document.body.classList.toggle('shop-plus-panel-open', hasOpenMenu);
      if (hasOpenMenu && shopPlusDesktopQuery.matches) lockShopPlusScroll();
      else unlockShopPlusScroll();
    };

    shopPlusDesktopQuery.addEventListener('change', updateShopPlusGlobalState);

    document.querySelectorAll('.shop-plus-menu__cards').forEach((cardsRoot) => {
      cardsRoot.addEventListener('pointermove', (event) => {
        if (!shopPlusDesktopQuery.matches) return;
        const rect = cardsRoot.getBoundingClientRect();
        cardsRoot.style.setProperty('--x', event.clientX - rect.left);
        cardsRoot.style.setProperty('--y', event.clientY - rect.top);
      });
    });

    shopPlusItems.forEach((item) => {
      const panel = item.querySelector('.shop-plus-menu__panel');
      if (!panel) return;
      let closeTimer = null;
      const CLOSE_DELAY_MS = 90;
      const syncPanelTop = () => {
        const headerSection =
          document.querySelector('.shopify-section-group-header-group .section-header') ||
          document.querySelector('.section-header');
        if (!headerSection) return;
        const headerBottom = Math.max(0, Math.round(headerSection.getBoundingClientRect().bottom));
        const tickerBottom = Array.from(headerSection.querySelectorAll('.header-ticker-block'))
          .reduce((maxBottom, el) => Math.max(maxBottom, Math.round(el.getBoundingClientRect().bottom)), 0);
        const panelTop = Math.max(headerBottom, tickerBottom, 0);
        panel.style.setProperty('--shop-plus-panel-top', `${panelTop}px`);
      };
      const cancelClose = () => {
        if (!closeTimer) return;
        window.clearTimeout(closeTimer);
        closeTimer = null;
      };
      const scheduleClose = () => {
        cancelClose();
        closeTimer = window.setTimeout(() => {
          if (isCursorOrFocusInsideMenu()) {
            openMenu();
            closeTimer = null;
            return;
          }
          item.classList.remove('is-open');
          updateShopPlusGlobalState();
          closeTimer = null;
        }, CLOSE_DELAY_MS);
      };

      const openMenu = () => {
        cancelClose();
        syncPanelTop();
        shopPlusItems.forEach((otherItem) => {
          if (otherItem !== item) otherItem.classList.remove('is-open');
        });
        item.classList.add('is-open');
        updateShopPlusGlobalState();
      };

      const closeMenu = () => {
        cancelClose();
        item.classList.remove('is-open');
        updateShopPlusGlobalState();
      };

      const isCursorOrFocusInsideMenu = () => {
        return item.matches(':hover') || panel.matches(':hover') || item.contains(document.activeElement);
      };

      const closeIfOutside = (event) => {
        const nextTarget = event.relatedTarget;
        if (nextTarget && (item.contains(nextTarget) || panel.contains(nextTarget))) {
          openMenu();
          return;
        }
        scheduleClose();
      };

      item.addEventListener('pointerenter', openMenu);
      item.addEventListener('pointerleave', closeIfOutside);
      panel.addEventListener('pointerenter', openMenu);
      panel.addEventListener('pointerleave', () => scheduleClose());
      item.addEventListener('focusin', openMenu);
      item.addEventListener('focusout', closeIfOutside);
      window.addEventListener('resize', syncPanelTop, { passive: true });
      syncPanelTop();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rushngo-footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('localization-form')) {
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          button: this.querySelector('button'),
          panel: this.querySelector('.disclosure__list-wrapper'),
        };
        this.elements.button.addEventListener('click', this.openSelector.bind(this));
        this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
        this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
      }

      hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
      }

      onContainerKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;
        this.hidePanel();
        this.elements.button.focus();
      }

      onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector('form');
        this.elements.input.value = event.currentTarget.dataset.value;
        if (form) form.submit();
      }

      openSelector() {
        this.elements.button.focus();
        this.elements.panel.toggleAttribute('hidden');
        this.elements.button.setAttribute(
          'aria-expanded',
          (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
        );
      }

      closeSelector(event) {
        const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
        if (event.relatedTarget === null || shouldClose) {
          this.hidePanel();
        }
      }
    }

    customElements.define('localization-form', LocalizationForm);
  }

  } catch(e) { console.error(e); }
})();
})();
